// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"159":"pay-result","982":"product-detail"}[chunkId] + "." + {"159":"86607b0a","982":"967e4ef7"}[chunkId] + ".js";
};